<div class="logo" [ngClass]="['logo--' + position, 'logo--' + size]">
	<ng-container *ngIf="linkType === 'href'; else routerLinkTemp">
		<a [attr.qa-id]="'logo_link'" [href]="link" class="{{ brandLearner ? 'logo__brand-learner' : 'logo__brand' }}"  [ngClass]="'logo__brand--' + size" [attr.aria-label]="altTag || ('lup.a11y.logo' | translate)"></a>
	</ng-container>
	<ng-template #routerLinkTemp>
		<a [attr.qa-id]="'logo_link'" [routerLink]="link" class="{{ brandLearner ? 'logo__brand-learner' : 'logo__brand' }}" [ngClass]="'logo__brand--' + size" [attr.aria-label]="altTag || ('lup.a11y.logo' | translate)"></a>
	</ng-template>
</div>
